import { ReactElement, use } from 'react';

import WanderingBoundaryRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-row-provider-context';
import WanderingBoundaryRowCreation from 'features/wandering-boundary-settings/views/wandering-boundary-row/wandering-boundary-row-creation.component';
import WanderingBoundaryRowEditing from 'features/wandering-boundary-settings/views/wandering-boundary-row/wandering-boundary-row-editing.component';
import WanderingBoundaryRowViewing from 'features/wandering-boundary-settings/views/wandering-boundary-row/wandering-boundary-row-viewing.component';

const WanderingBoundaryRow = (): ReactElement => {
  const { viewingMode } = use(WanderingBoundaryRowProviderContext);

  switch (viewingMode) {
    case 'creation':
      return <WanderingBoundaryRowCreation />;
    case 'editing':
      return <WanderingBoundaryRowEditing />;
    case 'viewing':
      return <WanderingBoundaryRowViewing />;
    default:
      return <></>;
  }
};

export default WanderingBoundaryRow;
